import { ExternalLink, DollarSign, TrendingUp } from "lucide-react";

const learnLinks = [
  {
    name: "TradingView",
    description: "Live stock and forex charts, market analysis and trading ideas",
    url: "https://www.tradingview.com/",
    icon: "📈",
  },
  {
    name: "Investopedia Stock Simulator",
    description: "Practice buying stocks and forex with virtual money — no risk",
    url: "https://www.investopedia.com/simulator/games",
    icon: "🎓",
  },
  {
    name: "Finviz",
    description: "Stock screener, market maps and financial news at a glance",
    url: "https://finviz.com/",
    icon: "📊",
  },
];

const dayTradingLinks = [
  {
    name: "BabyPips — School of Pipsology",
    description: "The best free step-by-step school for learning forex trading",
    url: "https://www.babypips.com/learn/forex",
    icon: "📚",
  },
  {
    name: "Webull Paper Trading",
    description: "Practice day trading with live market data and virtual money — no risk",
    url: "https://www.webull.com/paper-trading",
    icon: "📉",
  },
  {
    name: "Forex Factory Calendar",
    description: "Economic calendar — know exactly when big news will move the market",
    url: "https://www.forexfactory.com/calendar",
    icon: "🗓️",
  },
  {
    name: "StockTwits",
    description: "See what stocks and crypto other traders are watching right now",
    url: "https://stocktwits.com/",
    icon: "💬",
  },
];

const tradingJournalLinks = [
  { name: "TraderSync", description: "Auto-import trades and analyze your performance", url: "https://tradersync.com/", icon: "📓" },
  { name: "Edgewonk", description: "Trading journal with deep performance analytics", url: "https://edgewonk.com/", icon: "📓" },
  { name: "TraderVue", description: "Journal, review and share your trades", url: "https://www.tradervue.com/", icon: "📓" },
  { name: "TradeMetria", description: "Free trading journal and trade analytics", url: "https://www.trademetria.com/", icon: "📓" },
  { name: "TradesViz", description: "Advanced journaling, charts and trade statistics", url: "https://tradesviz.com/", icon: "📓" },
  { name: "TradeBench", description: "Free trading journal, planner and risk tools", url: "https://tradebench.com/", icon: "📓" },
  { name: "Financial Tech Wiz", description: "Free spreadsheet templates and trading tools", url: "https://financialtechwiz.com/", icon: "🧰" },
  { name: "Google Sheets", description: "Build your own free trading journal spreadsheet", url: "https://sheets.google.com/", icon: "📗" },
];

const tradingPlatformLinks = [
  { name: "MarketSmith", description: "Investor's Business Daily stock research platform", url: "https://marketsmith.investors.com/", icon: "🔬" },
  { name: "Trade Ideas", description: "AI-powered stock scanner and trade alerts", url: "https://www.trade-ideas.com/", icon: "🤖" },
  { name: "Stock Rover", description: "Deep stock screening and portfolio analytics", url: "https://www.stockrover.com/", icon: "🔬" },
  { name: "TrendSpider", description: "Automated chart analysis and trend detection", url: "https://trendspider.com/", icon: "📈" },
  { name: "TC2000", description: "Charting, screening and trading platform", url: "https://www.tc2000.com/", icon: "📈" },
  { name: "Zacks", description: "Stock ratings, rankings and research reports", url: "https://www.zacks.com/", icon: "⭐" },
  { name: "Yahoo Finance", description: "Free market news, quotes and portfolio tracking", url: "https://finance.yahoo.com/", icon: "📰" },
  { name: "Barchart", description: "Top movers, unusual volume and options flow", url: "https://www.barchart.com/", icon: "📊" },
  { name: "Benzinga", description: "Fast market news, analyst ratings and trade ideas", url: "https://www.benzinga.com/", icon: "📰" },
];

const chartingLinks = [
  { name: "TrendSpider", description: "Automated chart analysis and trend detection", url: "https://trendspider.com/", icon: "📈", paid: true },
  { name: "TC2000", description: "Charting, screening and trading platform", url: "https://www.tc2000.com/", icon: "📈", paid: true },
  { name: "eSignal", description: "Professional charting and real-time market data", url: "https://www.esignal.com/", icon: "📈", paid: true },
  { name: "TradeStation", description: "Pro-grade charting and trading platform", url: "https://www.tradestation.com/", icon: "📈", paid: true },
  { name: "TradingView", description: "Live stock and forex charts, market analysis", url: "https://www.tradingview.com/", icon: "📈", paid: false },
  { name: "GoCharting", description: "Free real-time charts for stocks, forex and crypto", url: "https://gocharting.com/", icon: "📈", paid: false },
  { name: "StockCharts", description: "Free classic charting and technical analysis", url: "https://stockcharts.com/", icon: "📈", paid: false },
  { name: "Finviz", description: "Stock screener, market maps and financial news", url: "https://finviz.com/", icon: "📊", paid: false },
];

const portfolioLinks = [
  { name: "Sharesight", description: "Track portfolio performance and dividends", url: "https://www.sharesight.com/", icon: "💼", paid: true },
  { name: "Stock Rover", description: "Deep portfolio analytics and screening", url: "https://www.stockrover.com/", icon: "💼", paid: true },
  { name: "Kubera", description: "Track all your investments in one dashboard", url: "https://www.kubera.com/", icon: "💼", paid: true },
  { name: "Morningstar", description: "Portfolio X-ray, ratings and fund research", url: "https://www.morningstar.com/", icon: "💼", paid: true },
  { name: "Yahoo Finance", description: "Free portfolio tracking and market news", url: "https://finance.yahoo.com/portfolios", icon: "💼", paid: false },
  { name: "Fidelity", description: "Free portfolio tools and research", url: "https://www.fidelity.com/", icon: "💼", paid: false },
  { name: "Charles Schwab", description: "Free portfolio tracking and market research", url: "https://www.schwab.com/", icon: "💼", paid: false },
  { name: "Seeking Alpha", description: "Portfolio tracking with crowd-sourced analysis", url: "https://seekingalpha.com/", icon: "💼", paid: false },
  { name: "Investing.com", description: "Free portfolio watchlist and global markets", url: "https://www.investing.com/", icon: "💼", paid: false },
];

const newsResearchLinks = [
  { name: "Benzinga Pro", description: "Real-time news feed and audio squawk", url: "https://pro.benzinga.com/", icon: "📰", paid: true },
  { name: "Market Chameleon", description: "Options flow and unusual activity research", url: "https://marketchameleon.com/", icon: "📰", paid: true },
  { name: "Bloomberg", description: "Global financial news and analysis", url: "https://www.bloomberg.com/", icon: "📰", paid: true },
  { name: "Barron's", description: "Market analysis and investment ideas", url: "https://www.barrons.com/", icon: "📰", paid: true },
  { name: "The Wall Street Journal", description: "Business and markets journalism", url: "https://www.wsj.com/", icon: "📰", paid: true },
  { name: "CNBC", description: "Live market TV and breaking finance news", url: "https://www.cnbc.com/", icon: "📰", paid: false },
  { name: "MarketWatch", description: "Free market news and watchlists", url: "https://www.marketwatch.com/", icon: "📰", paid: false },
  { name: "Seeking Alpha", description: "Crowd-sourced stock analysis and news", url: "https://seekingalpha.com/", icon: "📰", paid: false },
  { name: "Yahoo Finance", description: "Free market news and quotes", url: "https://finance.yahoo.com/", icon: "📰", paid: false },
  { name: "Investing.com", description: "Free global markets news and data", url: "https://www.investing.com/", icon: "📰", paid: false },
];

const LinkCard = ({ link, groupKey }) => (
  <a
    href={link.url}
    target="_blank"
    rel="noopener noreferrer"
    className="group flex items-center justify-between bg-[#0A0A0A] border border-white/5 hover:border-[#D4AF37]/50 p-4 transition-all duration-300"
    data-testid={`${groupKey}-link-${link.name.toLowerCase().replace(/[^a-z]/g, '-')}`}
  >
    <div className="flex items-center gap-3">
      <span className="text-xl">{link.icon}</span>
      <div>
        <h3 className="font-semibold text-white group-hover:text-[#D4AF37] transition-colors text-sm">
          {link.name}
          {link.paid !== undefined && (
            <span className={`ml-2 text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded-sm align-middle ${
              link.paid ? "bg-[#D4AF37]/15 text-[#D4AF37]" : "bg-emerald-500/15 text-emerald-400"
            }`}>
              {link.paid ? "Paid" : "Free"}
            </span>
          )}
        </h3>
        <p className="text-xs text-muted-foreground">{link.description}</p>
      </div>
    </div>
    <ExternalLink className="w-4 h-4 text-muted-foreground group-hover:text-[#D4AF37]" />
  </a>
);

const TradingPage = () => {
  return (
    <div className="pt-20 min-h-screen" data-testid="trading-page">
      {/* Header */}
      <section className="py-16 border-b border-white/5">
        <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-24">
          <span className="text-sm uppercase tracking-widest text-[#D4AF37]">Stocks & Forex</span>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mt-4 font-serif">
            Learn Trading & Investing
          </h1>
          <p className="text-muted-foreground mt-4">
            Free schools, practice accounts, tools and research for stocks, forex and day trading.
          </p>
        </div>
      </section>

      {/* Learn Stocks & Forex */}
      <section className="py-12 border-b border-white/5">
        <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="flex items-center gap-3 mb-6">
            <TrendingUp className="w-7 h-7 text-[#D4AF37]" />
            <h2 className="text-2xl md:text-3xl font-semibold font-serif">Learn Stocks & Forex</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {learnLinks.map((link) => <LinkCard key={link.name} link={link} groupKey="learn" />)}
          </div>
        </div>
      </section>

      {/* Day Trading */}
      <section className="py-12 border-b border-white/5 bg-[#0A0A0A]/50">
        <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="flex items-center gap-3 mb-6">
            <DollarSign className="w-7 h-7 text-[#D4AF37]" />
            <h2 className="text-2xl md:text-3xl font-semibold font-serif">Day Trading</h2>
          </div>
          <p className="text-sm text-muted-foreground mb-6">
            Learn first, practice with virtual money, then trade. Day trading involves real risk.
          </p>
          <div className="grid md:grid-cols-2 gap-4">
            {dayTradingLinks.map((link) => <LinkCard key={link.name} link={link} groupKey="daytrade" />)}
          </div>
        </div>
      </section>

      {/* Trading Tools */}
      <section className="py-12">
        <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="flex items-center gap-3 mb-6">
            <DollarSign className="w-7 h-7 text-[#D4AF37]" />
            <h2 className="text-2xl md:text-3xl font-semibold font-serif">Trading Tools</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            {[
              { title: "Trading Journals & Tracking", key: "journal", links: tradingJournalLinks },
              { title: "Platforms, Screeners & Research", key: "platform", links: tradingPlatformLinks },
              { title: "Charting Platforms", key: "charting", links: chartingLinks },
              { title: "Portfolio Tracking", key: "portfolio", links: portfolioLinks },
              { title: "News & Research", key: "news", links: newsResearchLinks },
            ].map((group) => (
              <div key={group.title}>
                <p className="text-xs uppercase tracking-widest text-[#D4AF37] mb-3">{group.title}</p>
                <div className="space-y-3">
                  {group.links.map((link) => <LinkCard key={link.name} link={link} groupKey={group.key} />)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TradingPage;
